import React from "react";
import city from "../assets/images/city.png";
const Footer = () => (
  <React.Fragment>
    <div className="content">
      <div className="page-group center-text">
        <img src={city} className="footer-img" alt="Smart City" />
      </div>
    </div>
    <footer>
      <div className="content center-text">
        <ul>
          <li>Projects</li>
          <li>Contact me</li>
          <li>YouTube</li>
          <li>GitHub</li>
          <li>CodeTuts</li>
        </ul>
      </div>
    </footer>
  </React.Fragment>
);

export default Footer;
